import React from 'react';
import { Link } from 'react-router-dom';
import { trackAnalyticsEvent } from '../services/analytics';

const Footer: React.FC = () => (
  <footer style={{ background: '#1a237e', color: '#fff', padding: '40px 20px', marginTop: '60px' }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(200px, 100%), 1fr))', gap: '20px', marginBottom: '32px' }}>
        <div>
          <h3 style={{ margin: '0 0 12px', fontSize: '18px' }}>⭐ TopRatedRehabs</h3>
          <p style={{ margin: 0, opacity: 0.8, fontSize: '14px', lineHeight: 1.6 }}>
            Connecting individuals and families with the best addiction treatment centers and sober living homes across the United States.
          </p>
        </div>
        <div>
          <h4 style={{ margin: '0 0 12px', fontSize: '14px', textTransform: 'uppercase', opacity: 0.7 }}>Browse</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px' }}>
            <a href="/rehabs/florida" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>Florida Rehabs</a>
            <a href="/rehabs/california" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>California Rehabs</a>
            <a href="/rehabs/texas" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>Texas Rehabs</a>
            <a href="/rehabs/new-york" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>New York Rehabs</a>
            <a href="/rehabs" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>All States →</a>
          </div>
        </div>
        <div>
          <h4 style={{ margin: '0 0 12px', fontSize: '14px', textTransform: 'uppercase', opacity: 0.7 }}>Treatment Types</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px' }}>
            <Link to="/search?type=Detox" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>Detox Centers</Link>
            <Link to="/search?type=Inpatient" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>Inpatient Rehab</Link>
            <Link to="/search?type=Outpatient" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>Outpatient Programs</Link>
            <Link to="/search?type=Sober+Living" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>Sober Living</Link>
          </div>
        </div>
        <div>
          <h4 style={{ margin: '0 0 12px', fontSize: '14px', textTransform: 'uppercase', opacity: 0.7 }}>For Treatment Centers</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px' }}>
            <Link to="/advertise" style={{ color: '#f5a623', opacity: 0.95, textDecoration: 'none', fontWeight: 600 }}>📢 Advertise With Us</Link>
            <Link to="/add-listing" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>➕ Add Your Facility</Link>
            <Link to="/search" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>🔍 Claim Existing Listing</Link>
            <a href="https://admin.topratedrehabs.com" style={{ color: '#fff', opacity: 0.85, textDecoration: 'none' }}>🔐 Owner Login</a>
          </div>
        </div>
        <div>
          <h4 style={{ margin: '0 0 12px', fontSize: '14px', textTransform: 'uppercase', opacity: 0.7 }}>Get Help Now</h4>
          <p style={{ margin: '0 0 12px', opacity: 0.8, fontSize: '14px' }}>SAMHSA National Helpline (24/7)</p>
          <a href="tel:+18006624357" onClick={() => trackAnalyticsEvent('helpline_click', { placement: 'footer' })}
            style={{ color: '#f5a623', fontSize: '20px', fontWeight: 700, textDecoration: 'none' }}>
            1-800-662-4357
          </a>
          <p style={{ margin: '12px 0 0', opacity: 0.6, fontSize: '11px' }}>
            Free, confidential help from the U.S. Substance Abuse and Mental Health Services Administration
          </p>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px', fontSize: '12px', opacity: 0.6 }}>
        <span>© {new Date().getFullYear()} TopRatedRehabs.com. All rights reserved.</span>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          <a href="/about" style={{ color: '#fff', textDecoration: 'none' }}>About</a>
          <a href="/how-we-rank" style={{ color: '#fff', textDecoration: 'none' }}>How We Rank</a>
          <a href="/review-policy" style={{ color: '#fff', textDecoration: 'none' }}>Review Policy</a>
          <a href="/editorial-policy" style={{ color: '#fff', textDecoration: 'none' }}>Editorial Policy</a>
          <a href="/advertising-disclosure" style={{ color: '#fff', textDecoration: 'none' }}>Advertising Disclosure</a>
          <a href="/privacy" style={{ color: '#fff', textDecoration: 'none' }}>Privacy Policy</a>
          <a href="/terms" style={{ color: '#fff', textDecoration: 'none' }}>Terms of Use</a>
          <a href="/contact" style={{ color: '#fff', textDecoration: 'none' }}>Contact</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
